var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlsIcon = function SvgXlsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 11v32H19.83c-.286.001-.57-.06-.83-.18-.22-.1-1-6.82-1-6.82s-6.72-.78-6.82-1a1.968 1.968 0 0 1-.18-.83V11h26Z",
    fill: "#24C69A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35v7.82c-.22-.1-.42-.24-.59-.41l-6.82-6.82c-.17-.17-.31-.37-.41-.59H19Z",
    fill: "#A6EBD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19h-9a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5Zm0 1a.5.5 0 0 1 .5.5V23h-4.5v-3h4Zm-9.5.5a.5.5 0 0 1 .5-.5h4v3H19v-2.5Zm.5 6.5a.5.5 0 0 1-.5-.5V24h4.5v3h-4Zm9 0h-4v-3H29v2.5a.5.5 0 0 1-.5.5Z",
    fill: "#fff"
  })));
};
export default SvgXlsIcon;